import React from "react";

function TabV2(props) {
  return <div>{props.children}</div>;
}
export default TabV2;
